import { call, put, takeLatest, select } from 'redux-saga/effects';
import vneidSdkService from '../../../services/vneidSdkService';
import {
    fetchSdkList,
    fetchSdkListSuccess,
    fetchSdkListFailure,
    fetchInitData,
    fetchInitDataSuccess,
    fetchInitDataFailure,
    createSdk,
    createSdkSuccess,
    createSdkFailure,
    updateSdk,
    updateSdkSuccess,
    updateSdkFailure,
    deleteSdk,
    deleteSdkSuccess,
    deleteSdkFailure,
    fetchSdkLogs,
    fetchSdkLogsSuccess,
    fetchSdkLogsFailure,
    selectPage,
    selectPageSize,
    selectLogsPage,
    selectLogsPageSize,
    selectLogsFilters,
} from './sliceTab4';

// Worker Sagas
function* handleFetchSdkList() {
    try {
        const page = yield select(selectPage);
        const pageSize = yield select(selectPageSize);
        const response = yield call(vneidSdkService.getSdkList, { page, size: pageSize });
        yield put(fetchSdkListSuccess(response));
    } catch (error) {
        yield put(fetchSdkListFailure(error.message || 'Failed to fetch SDK list'));
    }
}

function* handleFetchInitData() {
    try {
        const response = yield call(vneidSdkService.getInit);
        yield put(fetchInitDataSuccess(response));
    } catch (error) {
        yield put(fetchInitDataFailure(error.message || 'Failed to fetch init data'));
    }
}

function* handleCreateSdk(action) {
    try {
        yield call(vneidSdkService.createSdk, action.payload);
        yield put(createSdkSuccess('SDK created successfully'));
        // Refresh list after create
        yield put(fetchSdkList());
    } catch (error) {
        yield put(createSdkFailure(error.message || 'Failed to create SDK'));
    }
}

function* handleUpdateSdk(action) {
    try {
        const { id, formData } = action.payload;
        yield call(vneidSdkService.updateSdk, id, formData);
        yield put(updateSdkSuccess('SDK updated successfully'));
        // Refresh list after update
        yield put(fetchSdkList());
    } catch (error) {
        yield put(updateSdkFailure(error.message || 'Failed to update SDK'));
    }
}

function* handleDeleteSdk(action) {
    try {
        yield call(vneidSdkService.deleteSdk, action.payload);
        yield put(deleteSdkSuccess('SDK deleted successfully'));
        // Refresh list after delete
        yield put(fetchSdkList());
    } catch (error) {
        yield put(deleteSdkFailure(error.message || 'Failed to delete SDK'));
    }
}

function* handleFetchSdkLogs() {
    try {
        const page = yield select(selectLogsPage);
        const pageSize = yield select(selectLogsPageSize);
        const filters = yield select(selectLogsFilters);

        const params = {
            page,
            size: pageSize,
        };

        // Add filters if set
        if (filters.unitId) {
            params.unitId = filters.unitId;
        }
        if (filters.fromDate) {
            params.fromDate = filters.fromDate;
        }
        if (filters.toDate) {
            params.toDate = filters.toDate;
        }

        const response = yield call(vneidSdkService.getSdkLogs, params);
        yield put(fetchSdkLogsSuccess(response));
    } catch (error) {
        yield put(fetchSdkLogsFailure(error.message || 'Failed to fetch SDK logs'));
    }
}

// Watcher Saga
export function* watchVneidSdkActions() {
    yield takeLatest(fetchSdkList.type, handleFetchSdkList);
    yield takeLatest(fetchInitData.type, handleFetchInitData);
    yield takeLatest(createSdk.type, handleCreateSdk);
    yield takeLatest(updateSdk.type, handleUpdateSdk);
    yield takeLatest(deleteSdk.type, handleDeleteSdk);
    yield takeLatest(fetchSdkLogs.type, handleFetchSdkLogs);
}
